// Export a generic type which can have any key from the type parameter T as a key and string array as value.
// For example, if T is { a: string } then ModelState<T> can be { a: string[] }
export type ModelState<T> = {
    [K in keyof T]?: string[];

    // TODO: Support also nested properties and arrays. See FieldPath from react-hook-form as example.
}

export interface FieldError<T> {
    key: keyof T
    messages: string[]
}

export class BadRequestError<T> extends Error {
    constructor(public modelState: ModelState<T>) {
        super('Bad Request');
    }

    get fieldErrors(): FieldError<T>[] {
        return Object.keys(this.modelState as ModelState<T>).map(x => ({
            key: (x[0].toLowerCase() + x.slice(1)) as keyof T,
            messages: this.modelState[x as keyof T] as string[]
        }))
    }
}